export const CLASS_COLOR_CUSTOM_SELECT_VALUE = '__custom__';

export const colorOptions = [
  { value: '#FCE4EC', label: 'Light Pink' },
  { value: '#F8BBD0', label: 'Soft Rose' },
  { value: '#E1F5FE', label: 'Pale Blue' },
  { value: '#B3E5FC', label: 'Baby Blue' },
  { value: '#E8F5E9', label: 'Mint Green' },
  { value: '#C8E6C9', label: 'Light Pastel Green' },
  { value: '#FFFDE7', label: 'Light Yellow' },
  { value: '#FFF9C4', label: 'Soft Lemon' },
  { value: '#FFEBEE', label: 'Light Blush' },
  { value: '#F3E5F5', label: 'Soft Lavender' },
  { value: '#EDE7F6', label: 'Light Purple' },
  { value: '#F9FBE7', label: 'Pale Lime' },
  { value: '#FFE0B2', label: 'Light Apricot' },
  { value: '#FFCCBC', label: 'Pastel Coral' },
  { value: '#F5F5F5', label: 'Light Gray' },
];

function normalizeHexForCompare(s: string): string {
  return s.trim().toLowerCase();
}

export type ClassColorPreset = (typeof colorOptions)[number];

/** Case-insensitive match of `color` to a preset `colorOptions` entry. */
export const getPresetClassColorMatch = (
  color: string | undefined | null,
): ClassColorPreset | undefined => {
  if (color == null || color === '') {
    return undefined;
  }
  const normalized = normalizeHexForCompare(color);
  return colorOptions.find(
    (c) => normalizeHexForCompare(c.value) === normalized,
  );
};
